/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Schedule_OverlapInputs */

const vi_error_irrigation_schedule_overlap = /** @type {(inputs: Error_Irrigation_Schedule_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các lần tưới đang chồng nhau hoặc cách nhau chưa đủ 1 phút. Dời giờ hoặc giảm thời lượng.`)
};

/**

* @param {Error_Irrigation_Schedule_OverlapInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_schedule_overlap = /** @type {((inputs?: Error_Irrigation_Schedule_OverlapInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Schedule_OverlapInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_schedule_overlap(inputs)
});